import request from 'utils/request_ajax';

export const replaceCAToken = async accessToken => {
  if (accessToken === null || accessToken.trim() === '') {
    return 'accessToken is required';
  }

  try {
    await request.get('/content', { seismicToken: accessToken, replace: 1 });
    return 'success';
  } catch {
    return 'failed';
  }
};
